import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useStore from '@/store/useStore';
import { getSelectedMerchantId, normalizeStoreId } from '@/lib/routes';

export default function useStoreContext() {
  const { merchantId } = useParams();
  const setCurrentMerchantId = useStore((s) => s.setCurrentMerchantId);

  const resolvedMerchantId = normalizeStoreId(merchantId || getSelectedMerchantId());

  useEffect(() => {
    if (merchantId) {
      setCurrentMerchantId(normalizeStoreId(merchantId));
    }
  }, [merchantId, setCurrentMerchantId]);

  return resolvedMerchantId;
}
